type ProcessMonitorIconProps = {
  className?: string
}

const ProcessMonitorIcon = ({ className }: ProcessMonitorIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M11.5312 6.04651C11.5312 3.01735 9.07566 0.468783 6.04648 0.468783C4.52098 0.468783 3.12701 1.12313 2.13281 2.15588"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.46875 1.54688V2.88281C0.46875 3.40059 0.888469 3.82031 1.40625 3.82031H2.74219"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.46875 5.95316C0.46875 8.98231 2.92434 11.5309 5.95352 11.5309C7.47902 11.5309 8.87299 10.8762 9.86719 9.84338"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5312 10.4528V9.11682C11.5312 8.59904 11.1115 8.17932 10.5937 8.17932H9.25781"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.45312 4.00781V4.53516C4.45312 5.34417 5.10649 6 5.91244 6H6.08756C6.89351 6 7.54688 5.34417 7.54688 4.53516V4.00781C7.54688 3.68421 7.28555 3.42188 6.96316 3.42188H5.03684C4.71445 3.42188 4.45312 3.68421 4.45312 4.00781Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.45312 7.99219V7.46484C4.45312 6.65583 5.10649 6 5.91244 6H6.08756C6.89351 6 7.54688 6.65583 7.54688 7.46484V7.99219C7.54688 8.31579 7.28555 8.57812 6.96316 8.57812H5.03684C4.71445 8.57812 4.45312 8.31579 4.45312 7.99219Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.2876 8.40698L5.80821 7.88637C5.91804 7.77654 6.09612 7.77654 6.20597 7.88637L6.72657 8.40698"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ProcessMonitorIcon
